import styles from '../Terms.module.css';

export const PrivacyPolicyPage = () => {
	return (
		<div className={styles.container}>
			<h1 className={styles.title}>Политика конфиденциальности</h1>
			<pre className={styles.text}>
				{
				`
1. Общие положения

В целях настоящего Положения используются следующие основные понятия:

1.1. Настоящая Политика конфиденциальности сервиса EazyPass (далее – Политика) регулирует отношения между ООО "Интегроплэй" (далее - Исполнитель) и пользователем сети Интернет/пользователем Сервиса EazyPass (далее - Пользователь), связанные с обработкой персональных данных Пользователя, включая действия по получению, хранению, комбинированию, передаче персональных данных Пользователей или иному их использованию в целях, установленных Политикой.

1.2. Положение разработано в соответствии с Конституцией Российской Федерации, Федеральным законом "Об информации, информационных технологиях и о защите информации" N 149-ФЗ от 27.07.2006 года, Федеральным законом "О персональных данных" N 152-ФЗ от 27.07.2006 года и другими определяющими случаи и особенности обработки персональных данных нормативно-правовыми актами.

2. Основные понятия, используемые в Политике

2.1. Персональные данные - любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);

2.2. Персональные данные, разрешенные субъектом персональных данных для распространения, - персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном настоящим Федеральным законом;

2.3. Оператор - государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными;

2.4 Обезличивание персональных данных - действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных;

- Улучшения качества обслуживания и функционала Сервиса;

2.5. Обработка персональных данных - любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;

2.6. автоматизированная обработка персональных данных - обработка персональных данных с помощью средств вычислительной техники;

2.7. Иные термины, используемые в Политике, используются в значении, установленные Пользовательским соглашением об использовании сервиса АОКИ (далее – Пользовательское соглашение), размещенное по адресу: https://t.me/eazypassbot.

3. Сфера действия

3.1. Политика распространяется на Пользователей вне зависимости от их местонахождения.

3.2. Политика действует в отношении всей информации, которую Исполнитель может получить от Пользователя в результате пользования Сервисом и в ходе исполнения любых соглашений и договоров с Пользователем.

3.3. Пользование Сервисом означает безоговорочное согласие на присоединение Пользователя к Политике и указанными в ней условиями обработки его персональных данных.

3.4. В случае несогласия с этими условиями Пользователь должен воздержаться от использования Сервиса.

4. Категории обрабатываемых данных, в том числе, персональных данных

4.1. Исполнитель собирает информацию, которую Пользователь непосредственно предоставляет, когда намерен использовать Сервис, обращается к Исполнителю за помощью или иным образом взаимодействует с Исполнителем. Эта информация может включать в себя: имя, адрес электронной почты, номер телефона, способ оплаты, заказы, и прочую информацию, которую Пользователь может предоставлять.

4.2. Когда Пользователь пользуется Сервисом, Исполнитель собирает о нем следующие данные:

4.2.1. Сведения о местонахождении: Исполнитель может определять примерное местонахождение Пользователя по его IP-адресу.

4.2.2. Сведения о мобильном устройстве: Исполнитель может собирать сведения о мобильном устройстве Пользователя, включая, модель устройства, операционную систему и версию, название, уникальный идентификатор устройства, рекламные идентификаторы, серийный номер, данные о перемещении устройства и сведения мобильной сети.

4.2.3. Сведения об операциях: Исполнитель собирает сведения об операциях, связанных с пользованием Сервиса, включая размещенные Заказы и в рамках Сервиса, дату и время оказания услуг, ее стоимость, продолжительность и прочие соответствующие данные об операции.

4.2.4. Данные операций: во время взаимодействия Пользователя с Сервисом Исполнителем собирает данные с сервера, которые могут включать информацию об IP-адресе устройства, дате и времени входа, функциях приложения или просмотренных страницах, сбоях приложения или иных действиях системы, типе браузера, а также о сторонних сайтах или услугах, которыми Пользователь пользовался до взаимодействия с Сервисом.

4.2.5. Исполнитель может получать информацию из других источников и объединять ее с информацией, собираемой ей через Сервис.

4.3. За исключением случая, установленного в п. 4.1 Политики, вся обрабатываемая Исполнителем информация является обезличенной, то есть не позволяет идентифицировать конкретного субъекта персональных данных.

5. Цели использования информации

5.1. Исполнитель имеет право использовать информацию, полученную о Пользователе, только в следующих целях:

5.1.1. Для исполнения обязательств Исполнителя перед Пользователем в рамках Пользовательского соглашения;

5.1.2. Для предоставления, обслуживания и усовершенствования Сервиса;

5.1.3. Для осуществления внутренних операций, а именно, для предотвращения мошенничества и злоупотребления Сервисом; для устранения ошибок программного обеспечения и технических неисправностей; для проведения анализа данных и исследований; для контроля и анализа использования и тенденций в работе.

5.1.4. Для отправки сообщений или облегчения взаимодействия между Пользователем и Исполнителем;

5.1.5. Для отправки Пользователю сообщений, которые, по мнению Исполнителя, могут заинтересовать Пользователя, в том числе, о продуктах, услугах, рекламных акциях, новостях и мероприятиях и других компаний Сервиса, когда это разрешено в соответствии с действующим законодательством;

6. Обмен информацией

6.1. Исполнитель имеет право обмениваться информацией, полученной о Пользователе:

6.1.1. со своими сотрудниками и/или работниками, с которыми Исполнитель заключил трудовой договор или договор гражданско-правового характера.

6.1.2. в ответ на законный информационный запрос компетентных органов, если Исполнитель уверен, что разглашение таких данных соответствует или требуется любым действующим по месту запроса и месту первичного получения информации законодательством, нормативно-правовым актом или судебным процессом.

6.1.3. с сотрудниками правоохранительных органов, органами государственной власти и прочими третьими лицами, если действующим законодательством установлена обязанность по раскрытию соответствующих персональных данных.

6.1.4. по другим причинам, если Пользователь согласится на передачу его информации в обобщенной и/или анонимной форме, которая объективно не позволит идентифицировать Пользователя, если иное не предусмотрено отдельными соглашениями Исполнителя и Пользователя.

7. Меры, принимаемые для обеспечения выполнения обязанностей при обработке персональных данных

7.1. Для обеспечения безопасности персональных данных Исполнитель принимает необходимые и достаточные организационные и технические меры для защиты от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий с персональными данными.

7.2. Обеспечение безопасности персональных данных достигается, в частности:

7.2.1. назначением лиц, ответственных за организацию обработки и обеспечение безопасности персональных данных;

7.2.2. определением угроз безопасности персональных данных при их обработке в информационных системах персональных данных;

7.2.3. оценкой возможного вреда, который может быть причинен субъектам персональных данных в случае нарушения Федерального закона № 152;

7.2.4. применением организационных и технических мер по обеспечению безопасности персональных данных;

7.2.5. учетом лиц, допущенных к обработке персональных данных;

7.2.6. учетом материальных носителей персональных данных;

7.2.7. обнаружением фактов несанкционированного доступа к персональным данным и принятием мер;

7.2.8. восстановлением персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к ним;

7.2.9. установлением правил доступа к персональным данным, обрабатываемым в информационной системе персональных данных, а также обеспечением регистрации и учета всех действий, совершаемых с персональными данными в информационной системе персональных данных;

7.2.10. ограничением доступа в помещения, где размещены технические средства, осуществляющие обработку персональных данных, а также хранятся носители информации;

7.2.11. контролем за принимаемыми мерами обеспечения безопасности персональных данных и уровня защищенности информационных систем персональных данных;

7.2.12. ознакомлением работников Исполнителя, непосредственно осуществляющих обработку персональных данных, с положениями законодательства РФ и внутренними нормативными документами в отношении обработки и защиты персональных данных.

7.3. Контроль за выполнением требований по защите персональных данных организуется и проводится самостоятельно и (или) с привлечением на договорной основе юридических лиц и индивидуальных предпринимателей, имеющих лицензию на осуществление деятельности по технической защите конфиденциальной информации.

7.4. Обработка персональных данных осуществляется с использованием баз данных, расположенных на территории РФ.

8. Рекламная политика

8.1. Пользователь может отказаться от получения рекламных сообщений от Исполнителя, воспользовавшись указаниями, приведенными в этих сообщениях. В случае, если Пользователь отказался, Исполнитель может присылать ему сообщения нерекламного характера.

9. Изменение Политики конфиденциальности

9.1. Исполнитель может периодически вносить изменения в Политику. В случае внесения существенных изменений в отношении обращения с персональными данными Пользователя или в Политику, Исполнитель уведомит Пользователя об этом через Сервис или по электронной почте. Продолжение пользования Сервисом после такого уведомления означает согласие Пользователя с изменениями. Рекомендуется периодически проверять Политику на предмет изменения условий.

11. Реквизиты

ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ИНТЕГРОПЛЭЙ"
ИНН 7814824698
КПП 781401001
ОГРН 1237800076007
Адрес для связи: eazypass.ru@gmail.com

`
			}
			</pre>
		</div>
	);
};